import React, { memo, useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Column, Row } from 'components/Layout/Grid';
import { RootState } from 'store/ducks';
import Select from 'components/Select';
import Text from 'components/Text';

import BrandServices from 'services/brand.service';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';

import { IOption } from 'components/Select/interface';
import { BrandProps } from './interface';

import { EnumCategories } from 'models/Ticket';
import { useOpenProtocolContext } from 'contexts/OpenProtocol';

const Brand: React.FC<BrandProps> = (props) => {

  const { protocolCategory, brands, setBrands } = props;

  const { setNameEnterpriseSelectedProtocol } = useOpenProtocolContext();

  const [brandOption, setBrandOption] = useState(Array<IOption>());
  const [allOptions, setAllOptions] = useState(Array<IOption>());

  const user = useSelector((state: RootState) => state.user);
  const order = useSelector((state: RootState) => state.openProtocolData?.order);

  const getBrands = useCallback(() => {
    new BrandServices()
      .get(undefined, undefined, 'name asc', {
        and: [
          { enable: { eq: true } }
        ]
      })
      .then((result: any) => {
        if (result && result.data) {
          const { data } = result;
          const _brandOption: Array<IOption> = new Array<IOption>();

          Object.keys(data).forEach((key) => {
            _brandOption.push({
              value: data[key].id,
              label: data[key].name,
              enterpriseCode: parseInt(data[key].enterpriseCode)
            });
          });

          setBrandOption(_brandOption);
          setAllOptions([..._brandOption]);

          addBrandName(_brandOption, brands);
        }
      });
  }, []);

  useEffect(() => {
    KeycloakPubServiceInstance.subscribe(() => {
      getBrands();
    });
  }, [getBrands]);

  useEffect(() => {
    if (protocolCategory === '10') {
      const filterOptionsMaintenance = allOptions.filter(x => x.enterpriseCode === 22);
      setBrandOption(filterOptionsMaintenance);
    } else {
      setBrandOption(allOptions);
    }
  }, [protocolCategory]);

  useEffect(() => {
    if ((order && order?.enterpriseCode === 98) &&
      (protocolCategory === EnumCategories.RECLAMACAO_TECNICA || protocolCategory === EnumCategories.DEVOLUCAO)) {
      conditionIsBrandAutoSelected();
    }
  }, [order, protocolCategory, brandOption]);

  const addBrandName = (brandOption: IOption[], value: string) => {
    if (value) {
      const nameBrand: string = brandOption
        .find((brand: IOption) => brand.value === value)?.label || "";

      setNameEnterpriseSelectedProtocol?.(nameBrand);
    }
  };

  const handleSetBrandSelected = (value: string) => {
    setBrands(value);

    addBrandName(brandOption, value);
  };

  const conditionIsBrandAutoSelected = () => {
    const brand: string = brandOption.find((b: IOption) => b.label === "Mafra Hospitalar - Distribuição")?.value || "";

    return handleSetBrandSelected(brand);
  };

  const isRequired = () => {
    if (user?.userType === 'employee')
      return true;

    return protocolCategory === EnumCategories.RECLAMACAO_TECNICA ||
      protocolCategory === EnumCategories.DEVOLUCAO;
  };

  return (
    <Row className="flex-md-column">
      <Column className="flex-1 mt-5">
        <Text className="mb-2 color-blue-gray" size={12}>
          Empresas Viveo
        </Text>
        <Select
          data-statename="brands"
          required={isRequired()}
          name="Marca"
          value={brands}
          onChange={(e) => handleSetBrandSelected(e.target.value)}
          className="w-lg-100"
          width={'240px'}
          options={brandOption}
          id="viveo-companies"
        />
      </Column>
    </Row>
  );
};

export default memo(Brand);
